import { Loader, Tabs } from "@mantine/core";
import { message, Select } from "antd";
import _ from "lodash";
import { QuillEditor } from "../../../components/quill-editor";
import { RequiredIndicator } from "../../../components";
import { consultationAtom } from "../../../helpers/state/consultation";
import { useQuery, useMutation } from "react-query";
import { getConsultationOnly, putConsultationOnly } from "../../../helpers/api";
import { useAtom } from "jotai";

const EditConsultationComponent = ({ consultationId, onRefresh }) => {
  const { Option } = Select;
  const [consultation, setConsultation] = useAtom(consultationAtom);

  const { isError, isFetching } = useQuery({
    queryFn: () => getConsultationOnly(consultationId),
    queryKey: ["consultation-only", consultationId],
    onSuccess: (data) => setConsultation(data),
    refetchOnWindowFocus: false,
  });

  const { mutateAsync: updateConsultation, isLoading } = useMutation(
    (data) => putConsultationOnly(data),
    {
      onSuccess: (data, variables, context) => {
        if (data.status === 200) {
          message.success(data.data.message);
          onRefresh();
          return;
        }
        throw data;
      },
      onError: (error, variables, context) => {
        const err = error.response?.data?.message;
        if (_.isArray(err)) {
          err.map((e) => message.error(e.message));
        } else {
          message.error(err);
        }
      },
    }
  );

  return (
    <>
      {isFetching ? (
        <div className="text-center">
          <Loader /> please wait...
        </div>
      ) : isError ? (
        <kbd className="bg-danger p-2">
          Sorry, we encountered an error processing your request
        </kbd>
      ) : (
        <>
          <div className="row mb-3">
            <div className="field">
              <label className="mb-0" htmlFor="callType">
                Consultation Type
                <RequiredIndicator />
              </label>
              <Select
                required
                autoFocus
                size="large"
                value={consultation.type}
                onChange={(v) => setConsultation({ ...consultation, type: v })}
                id="type"
                className="d-block"
                placeholder="consultation type">
                <Option value="Phone">Phone</Option>
                <Option value="Video">Video</Option>
                <Option value="Physical">Physical</Option>
              </Select>
            </div>
          </div>

          <Tabs
            defaultValue="complaint"
            variant="outline"
            color="green"
            className="mb-3">
            <Tabs.List className="mb-3">
              <Tabs.Tab value="complaint">Presenting Complaint</Tabs.Tab>
              <Tabs.Tab value="management">Management Plan</Tabs.Tab>
              <Tabs.Tab value="notes">Notes</Tabs.Tab>
              <Tabs.Tab value="investigation">Investigation</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="complaint" pt="xs">
              <div className="field">
                <QuillEditor
                  value={consultation.rawComplaint ?? ""}
                  onChange={(html) =>
                    setConsultation({ ...consultation, complaint: html })
                  }
                  placeholder="presenting complaint here. Patient will see this"
                />
              </div>
            </Tabs.Panel>

            <Tabs.Panel value="management" pt="xs">
              <div className="field">
                <QuillEditor
                  value={consultation.rawDoctorsAdvise ?? ""}
                  onChange={(html) =>
                    setConsultation({ ...consultation, doctorsAdvise: html })
                  }
                  placeholder="management plan (Doctor's Advice) here. Patient will see this"
                />
              </div>
            </Tabs.Panel>

            <Tabs.Panel value="notes" pt="xs">
              <div className="field">
                <QuillEditor
                  value={consultation.rawNotes ?? ""}
                  onChange={(html) =>
                    setConsultation({ ...consultation, notes: html })
                  }
                  placeholder="Clinical findings and comments. patient will not see this"
                />
              </div>
            </Tabs.Panel>

            <Tabs.Panel value="investigation" pt="xs">
              <div className="field">
                <QuillEditor
                  value={consultation.rawInvestigation ?? ""}
                  onChange={(html) =>
                    setConsultation({ ...consultation, investigation: html })
                  }
                  placeholder="investigation"
                />
              </div>
            </Tabs.Panel>
          </Tabs>

          <button
            onClick={() => updateConsultation(consultation)}
            id="submit"
            className={`button h6 text-white app-btn btn-prim mt-3 ${isLoading && " is-loading "
              }`}>
            Update Consultation
          </button>
        </>
      )}
    </>
  );
};

export default EditConsultationComponent;
